__turbopack_context__.v({
  "container": "CrqJPW_container",
  "detailPane": "CrqJPW_detailPane",
  "mapColumn": "CrqJPW_mapColumn",
  "modal": "CrqJPW_modal",
});
